import cognitoUserPool from './cognitoUserPool';

const cognitoSignOut = async () => {
  cognitoUserPool.getCurrentUser()?.signOut();
};

export default cognitoSignOut;
